import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function SectionPopup({ x, y, name, color, palette, onClose, onSetName, onSetColor, }) {
    return (_jsxs("div", { "data-menu-keep": "1", style: {
            position: 'fixed',
            left: x,
            top: y,
            zIndex: 55,
            width: 250,
            background: '#FFFFFF',
            border: '1px solid #E2E8F0',
            borderRadius: 12,
            boxShadow: '0 12px 32px rgba(15,23,42,.22)',
            padding: 14,
            display: 'flex',
            flexDirection: 'column',
            gap: 10,
        }, children: [_jsxs("div", { style: { display: 'flex', alignItems: 'center', gap: 8 }, children: [_jsx("span", { style: {
                            width: 12,
                            height: 12,
                            borderRadius: 3,
                            background: color,
                            border: '1px solid rgba(15,23,42,.12)',
                            flex: 'none',
                        } }), _jsx("span", { style: { fontSize: 13, fontWeight: 700, flex: 1 }, children: "\u0421\u0435\u043A\u0446\u0438\u044F" }), _jsx("button", { type: "button", onClick: onClose, className: "kp-option", style: {
                            border: 'none',
                            background: 'none',
                            color: '#94A3B8',
                            fontSize: 14,
                            cursor: 'pointer',
                            padding: '2px 6px',
                            borderRadius: 5,
                        }, children: "\u2715" })] }), _jsxs("label", { style: { display: 'flex', flexDirection: 'column', gap: 5, fontSize: 11.5, fontWeight: 600, color: '#334155' }, children: ["\u041D\u0430\u0437\u0432\u0430\u043D\u0438\u0435", _jsx("input", { type: "text", defaultValue: name, placeholder: "\u041F\u0443\u0441\u0442\u043E \u2014 \u0431\u0435\u0437 \u0437\u0430\u0433\u043E\u043B\u043E\u0432\u043A\u0430", onBlur: (e) => onSetName(e.currentTarget.value), style: {
                            height: 32,
                            border: '1px solid #CBD5E1',
                            borderRadius: 7,
                            padding: '0 8px',
                            fontSize: 12.5,
                            outline: 'none',
                            width: '100%',
                        } }, name)] }), _jsxs("div", { style: { display: 'flex', flexDirection: 'column', gap: 6 }, children: [_jsx("span", { style: { fontSize: 11.5, fontWeight: 600, color: '#334155' }, children: "\u0426\u0432\u0435\u0442" }), _jsx("div", { style: { display: 'flex', flexWrap: 'wrap', gap: 6 }, children: palette.map((p) => (_jsx("button", { type: "button", title: p.bg, onClick: () => onSetColor(p.bg), style: {
                                width: 22,
                                height: 22,
                                borderRadius: 6,
                                border: color === p.bg ? '2px solid #2563EB' : '1px solid rgba(15,23,42,.12)',
                                background: p.bg,
                                cursor: 'pointer',
                                padding: 0,
                                boxShadow: color === p.bg ? '0 0 0 2px #FFFFFF, 0 0 0 4px #2563EB' : 'none',
                            } }, p.bg))) })] })] }));
}
